import apiClient from './authService';

export const activityService = {
  getAll: (params = {}) =>
    apiClient.get('/api/activities', { params }).then(r => r.data),

  getUpcomingTasks: () =>
    apiClient.get('/api/activities/tasks/upcoming').then(r => r.data),

  getTasksSummary: () =>
    apiClient.get('/api/activities/tasks/summary').then(r => r.data),

  create: (data) =>
    apiClient.post('/api/activities', data).then(r => r.data),

  update: (id, data) =>
    apiClient.put(`/api/activities/${id}`, data).then(r => r.data),

  complete: (id) =>
    apiClient.put(`/api/activities/${id}`, { status: 'completed' }).then(r => r.data),

  reopen: (id) =>
    apiClient.put(`/api/activities/${id}`, { status: 'open' }).then(r => r.data),

  delete: (id) =>
    apiClient.delete(`/api/activities/${id}`).then(r => r.data),
};
